import axios from "axios"
import { buildAutorizationUrl, buildBaseUrl } from "./config"
import { makeArrayToast } from "../core/utils/toasts";
import { getFieldFromJwt } from "./utils";
import moment from "moment";




export async function getRolByAuthorizationBackend(jwt) {
  try {
    const authorizationResponse = await axios.post(buildAutorizationUrl(), { jwt });
    return authorizationResponse.data.message === "Unauthorized" ?
      null : authorizationResponse.data.rol || null;
  } catch (error) {
    console.error('Error en la solicitud a la uri: ' + buildAutorizationUrl(), error);
    return null;
  }
}


export async function validateJwt(jwt) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/validate`;

  try {
    const response = await axios.post(url, { jwt });
    if (response.status === 200) {
      console.log('Token validado correctamente:', response.data);
      return response.data;
    } else {
      console.error('Error al validar el token:', response.statusText);
      throw new Error('Error al validar el token');
    }
  } catch (error) {
    console.error('Error al realizar la solicitud POST:', error.message);
    throw error;
  }
}


export function getNit() {
  // Intentar obtener de la empresa activa en localStorage
  const activeCompanyStr = localStorage.getItem('activeCompany');
  if (activeCompanyStr) {
    try {
      const activeCompany = JSON.parse(activeCompanyStr);
      if (activeCompany && activeCompany.nit) {
        return activeCompany.nit;
      }
    } catch (e) {
      console.error('Error parsing activeCompany:', e);
    }
  }

  // Fallback al JWT tradicional
  return getFieldFromJwt('sub');
}

// Nueva función auxiliar para obtener todas las empresas disponibles
export function getAvailableCompanies() {
  return getFieldFromJwt('companies') || [];
}

// Nueva función para saber si es usuario multi-empresa
export function isMultiCompanyUser() {
  const companies = getAvailableCompanies();
  return companies.length > 1;
}


export async function getCompany() {
  return await getCompanyByNit(getNit());
}



export async function getDocuments(type, params = {}) {
  const { startDate, endDate, nit, uiid } = params;
  if (!nit) {
    params.nit = getNit();
  }

  /*
    Tipos de documento esperados:

    ANEXOS (CSV):
    - anexo:1  -> Anexo 1 - Ventas a contribuyentes
    - anexo:2  -> Anexo 2 - Ventas a consumidor final
    - anexo:3  -> Anexo 3 - Compras
    - anexo:5  -> Anexo 5 - Sujetos excluidos
    - anexo:8  -> Anexo 8 - Percepción del IVA 1% en compras
    - anexo:11 -> Anexo 11 - Anticipo de IVA 2% efectuado al declarante
    - anexo:13 -> Anexo 13 - Documentos legales anulados
    - donaciones -> Declaración de donaciones (no es anexo)

    LIBROS (PDF):
    - libro:contribuyente -> Libro de Contribuyente
    - libro:consumidor    -> Libro de Consumidor
    - libro:compras       -> Libro de Compras

    DOCUMENTOS INDIVIDUALES:
    - pdf:invoice  -> PDF de factura individual
    - json:invoice -> JSON de factura individual

    El parámetro 'params` puede tener:
    - startDate y endDate (para los anexos y libros)
    - nit (para pdf y libros)
    - uiid (para jsons y pdf)
  */

  let url = buildBaseUrl();
  let endpoint, typo;

  // Manejo especial para donaciones que no sigue el patrón endpoint:tipo
  if (type === 'donaciones') {
    url += `/documentos-tributarios/declaracion-donaciones`;
    endpoint = 'anexo'; // Tratarlo como anexo para el responseType
    typo = 'donaciones';
  } else {
    [endpoint, typo] = type.split(":");

    switch (endpoint) {
      case 'anexo':
        url += `/documentos-tributarios/anexo${typo}`;
        break;
      case 'libro':
        url += `/libros/libro-${typo}`;
        break;
      case 'libro-excel':
        url += `/libros/libro-${typo}-excel`;
        endpoint = 'libro'; // Tratarlo como libro para responseType blob
        break;
      case 'pdf':
        url += `/documentos-tributarios/pdf/${uiid}`;
        break;
      case 'json':
        url += `/documentos-tributarios/json/${uiid}`;
        break;
      default:
        throw new Error("Tipo de documento no válido.");
    }
  }

  /* 
    Formatear fechas con moment a 'YYYY-MM-DD' si se proporcionan
    ya que el backend lo recibe de esa manera
  */
  const queryParams = new URLSearchParams({
    nit: params.nit,
    fechaInicio: startDate ? moment(startDate).format('YYYY-MM-DD') : undefined,
    fechaFin: endDate ? moment(endDate).format('YYYY-MM-DD') : undefined
  }).toString();

  url += queryParams ? `?${queryParams}` : '';

  console.log("Esta es la URL: " + url);


  const config = {
    ...params
  };

  /* 
    Ajustar el responseType solo si es un libro por que es 
    un archivo pdf
  */
  if (endpoint === 'libro') {
    config.responseType = 'blob';
  }

  try {
    const response = await axios.get(url, config);
    console.log("Esto es el response: ", response);
    return response.data;
  } catch (error) {
    console.log("Error: ", error);
    return error.response?.data?.error ? error.response.data.error : `Ocurrió un error al tratar de leer los ${endpoint}s ${typo}`;
  }
}


/**funcion para listar usuarios */
export async function obtenerUsuarios(Nitcompany) {
  let url = buildBaseUrl();
  let nit = Nitcompany;
  try {
    const response = await axios.get(url + '/usuarios/nit/' + nit);
    console.log('URL completa:', response);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los usuarios:', error);
    return [];
  }

};

// Función para obtener las empresas con paginación
export async function getCompanies({
  offset = 0,
  limit = 10,
  buscar,
  nombre_empresa,
  nit,
  sector,
  ciudad,
  pais,
  activo,
  count = false,
  execute_pagination = true,
} = {}) {
  const baseUrl = buildBaseUrl();
  let url = `${baseUrl}/companies?offset=${offset * limit}&limit=${limit}`;

  if (buscar) {
    url += `&buscar=${encodeURIComponent(buscar)}`;
  }
  if (nombre_empresa) {
    url += `&nombre_empresa=${encodeURIComponent(nombre_empresa)}`;
  }
  if (nit) {
    url += `&nit=${encodeURIComponent(nit)}`;
  }
  if (sector) {
    url += `&sector=${encodeURIComponent(sector)}`;
  }
  if (ciudad) {
    url += `&ciudad=${encodeURIComponent(ciudad)}`;
  }
  if (pais) {
    url += `&pais=${encodeURIComponent(pais)}`;
  }
  if (activo !== undefined) {
    url += `&activo=${encodeURIComponent(activo)}`;
  }
  if (count) {
    url += `&count=true`;
  }
  if (!execute_pagination) {
    url += `&execute_pagination=false`;
  }

  try {
    console.log("esto es la url: ", url);
    const response = await axios.get(url);
    if (response.data && response.data.length > 0) {
      return response.data;
    } else {
      console.log('No se encontraron empresas.');
      if (response.data.totalRegistros !== undefined) {
        return response.data.totalRegistros;
      }
      return [];
    }
  } catch (error) {
    console.error('Error al obtener las empresas:', error);
    return [];
  }
}


export async function getLengthComapnies() {
  let baseUrl = buildBaseUrl();
  try {
    const url = baseUrl + `/companies`;

    const response = await axios.get(url);
    // Verificar si la respuesta contiene datos
    if (response.data && response.data.length > 0) {
      return response.data.length;
    } else {
      console.log('No se encontraron empresas.');
      return [];
    }
  } catch (error) {
    console.error('Error al obtener las empresas:', error);
    return [];
  }
}

export async function getCompanyByNit(nit) {
  let baseUrl = buildBaseUrl();
  try {
    const url = baseUrl + '/companies/' + nit;
    console.log('URL Compañia por Nit:', url);
    const response = await axios.get(url);
    // Verificar si la respuesta contiene datos
    if (response.data) {
      return response.data;
    } else {
      console.log('No se encontró la empresa con ese NIT.');
      return null;
    }
  } catch (error) {
    console.error('Error al obtener la empresa:', error);
    return null;
  }
}
/** Función para actualizar una empresa */
export async function actualizarEmpresa(nit, datosEmpresa) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/companies/${nit}`;

  try {
    const response = await axios.put(url, datosEmpresa);
    if (response.status >= 200 && response.status < 300) {
      console.log('Empresa actualizada correctamente:', response.data);
      return makeArrayToast(response.data.message ?
        response.data.message :
        "Empresa actualizada correctamente!", 1);
    } else {
      console.error('Error al actualizar la empresa:', response.statusText);
      return makeArrayToast('Hubo un error al actualizar la empresa', 1);
    }
  } catch (error) {
    console.error('Error al realizar la solicitud PUT:', error.message);
    return error.response && error.response.data && error.response.data.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}




/**Funcion Crear empresa */
export async function createCompany(companyData) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/companies`;
  try {
    const response = await axios.post(url, companyData);
    console.log("Company created successfully:", response);
    return response.status === 201 ?
      makeArrayToast(response.data.message ?
        response.data.message :
        "Empresa creada correctamente!", 1) :
      makeArrayToast('Hubo un error al crear la empresa', 1);
  } catch (error) {
    console.error('Error making POST request:', error);
    return error.response && error.response.data && error.response.data.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}

export async function actualizarEstadoEmpresa(nitEmpresa, isActive) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/companies/activate/${nitEmpresa}`;

  try {
    const response = await axios.put(url, { isActive });
    if (response.status >= 200 && response.status < 300) {
      console.log('Estado de la empresa actualizado correctamente:', response.data);
      return makeArrayToast(response.data.message, 1);
    } else {
      console.error('Hubo un error al actualizar el estado de la empresa:', response.statusText);
      return makeArrayToast('Error al actualizar el estado de la empresa', 1);
    }
  } catch (error) {
    console.error('Error al realizar la solicitud PUT:', error.message);
    return error.response && error.response.data && error.response.data.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}

/**Funciones para los enpoint de USUARIOS */
/* 
  Las respuestas de cada llamada de api deben de ser respondidas
  con un formato especifico, esto para que el dispash de show notification
  las capture y las pueda printiar en la pantalla

  Las respuestas de la api pueden ser:

  1. Un array (por multiples errores)
  2. Un string de todo bien (no siempre, controlar ese caso)
  3. Un string quemado de error

  el formato que espera el dispash es solamente un menssage
  y un codigo de error (0 fallo, 1 todo bien)
*/
export async function crearUsuario(datosUsuario) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/usuarios`;
  try {
    const response = await axios.post(url, datosUsuario);
    console.log("Esta es la verdadera respuesta: ", response);
    return response.status === 201 ?
      makeArrayToast(response.data.message, 1) :
      makeArrayToast('Hubo un error al crear el usuario', 1);
  } catch (error) {
    return error.response.data.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}


export function urlMenu() {
  const currentUrl = window.location.href;
  console.log(currentUrl);

  const url = currentUrl.split("/")
}

// Función para actualizar un usuario
export async function updateUser(email, nit, datosUsuario) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/usuarios/${encodeURIComponent(email)}/${encodeURIComponent(nit)}`;

  console.log("Datos del usuario: ", datosUsuario);

  try {
    const response = await axios.put(url, datosUsuario);

    if (response.status >= 200 && response.status < 300) {
      console.log('Usuario actualizado correctamente:', response.data);
      return makeArrayToast(response.data.message, 1);
    } else {
      console.error('Error al actualizar el usuario:', response.statusText);
      return makeArrayToast('Error al actualizar el usuario', 1);
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Error desconocido, contacte con los devs";
    console.error('Error al realizar la solicitud PUT:', error.message);
    return makeArrayToast(errorMessage, 0);
  }
}


export async function deleteUserByUsername(email, nit) {
  const emailEncoded = encodeURIComponent(email);
  const nitEncoded = encodeURIComponent(nit);
  const url = `${buildBaseUrl()}/usuarios/${emailEncoded}/${nitEncoded}`;
  try {
    const response = await axios.delete(url);
    console.log("Response delete user: ", response);
    return response.status === 200 ?
      makeArrayToast(`Usuario ${email} eliminado exitosamente.`, 1) :
      makeArrayToast('Error al eliminar el usuario', 1)
  } catch (error) {
    console.error(`Error al realizar la solicitud DELETE: ${error.message}`);
    return error.response && error.response.data && error.response.data.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}


export async function sendEmail(uiid) {
  const uiidEncoded = encodeURIComponent(uiid);
  const url = `${buildBaseUrl()}/documentos-tributarios/email/${uiidEncoded}`;
  try {
    const response = await axios.get(url);
    console.log("Esta es la respuesta: ", response);
    return response.status === 200 ?
      makeArrayToast(response.data.message, 1) :
      makeArrayToast('Error al mandar el email', 1)
  } catch (error) {
    console.error(`Error al realizar la solicitud DELETE: ${error.message}`);
    return error.response && error.response.data && error.response.data.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}


export async function getUserByEmail(email = null) {
  const emailUri = encodeURIComponent(email ? email : getEmailFromJwt());
  const url = `${buildBaseUrl()}/usuarios/email/${emailUri}`;
  try {
    console.log("esta es la urlL: ", url);
    const response = await axios.get(url);
    if (response.data && response.data.length > 0) {
      return response.data[0];
    } else {
      console.log('No se encontro el usuario.');
      console.log(response.data);
      if (response.data.totalRegistros) {
        return response.data.totalRegistros;
      }
      return [];
    }
  } catch (error) {
    console.error('Error al obtener las facturas:', error);
    return [];
  }
}




export async function getFacturas({
  offset = 0,
  limit = 100,
  count = false,
  fecha_desde,
  fecha_hasta,
  tipo_monto_mayor_que,
  tipo_monto_menor_que,
  tipo_monto_igual_que,
  fecha_dia,
  tipo_numero_documento_receptor,
  uuid = [],
  name_client,
  execute_pagination,
  order_by = 'desc',
  tipo_factura = [],
  anulado,
  certificado,
} = {}) {
  console.log("esto es el count ANTES: ", count);
  const baseUrl = buildBaseUrl();
  const nit = getNit();

  const buildQueryString = (params) => {
    return Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => {
        return Array.isArray(value) ?
          value
            .filter(val => val !== undefined && val !== null && val !== '')
            .map(val => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
            .join('&') :
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      })
      .join('&');
  };


  console.log("esto es el count DESPUES: ", count);
  const commonQueries = {
    offset: offset * limit,
    limit,
    nit,
    count: count ? 'true' : '',
    fecha_desde,
    fecha_hasta,
    tipo_monto_mayor_que,
    tipo_monto_menor_que,
    tipo_monto_igual_que,
    fecha_dia,
    tipo_numero_documento_receptor,
    name_client,
    execute_pagination,
    order_by,
    anulado,
    certificado
  };

  if (uuid.length > 0) {
    commonQueries.uuid = uuid;
  }

  if (tipo_factura.length > 0) {
    commonQueries.tipo_factura = tipo_factura;
  }

  const fetchData = async (queryParams) => {
    console.log("esto es query params ", queryParams);
    const url = `${baseUrl}/documentos-tributarios/busqueda/facturas?${buildQueryString(queryParams)}`;
    console.log("Fetching URL: (" + count + ")", url);
    try {
      const response = await axios.get(url);
      return count ? response.data.totalRegistros : (response.data || []);
    } catch (error) {
      console.error('Error fetching facturas:', error);
      return [];
    }
  };

  return await fetchData(commonQueries);
}


export function getRolByJwt() {
  return getFieldFromJwt("role") || "default";
}

export function getJwt() {
  return localStorage.getItem('token');
}

export function getEmailFromJwt() {
  return getFieldFromJwt("username");
}

export function getUsername() {
  return getFieldFromJwt("username") || "";
}

export function getRoles() {
  const role = getFieldFromJwt("role");
  return role ? [role] : [];
}

// ===== Funciones API para Contadores (Bookkeepers) =====

/**
 * Obtiene la lista de contadores de una empresa (owner)
 * @returns {Promise<Array>} Lista de contadores
 */
export async function getBookkeepers() {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/usuarios/bookkeepers`;
  try {
    const response = await axios.get(url);
    console.log('Contadores obtenidos:', response);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los contadores:', error);
    return [];
  }
}

/**
 * Crea un nuevo contador
 * @param {Object} bookkeeperData - Datos del contador (nombre, email, companies[])
 * @returns {Promise<Array>} Respuesta con mensaje de éxito/error
 */
export async function createBookkeeper(bookkeeperData) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/usuarios/bookkeepers`;
  try {
    const response = await axios.post(url, bookkeeperData);
    console.log("Contador creado:", response);
    return response.status === 201 ?
      makeArrayToast(response.data.message || 'Contador creado exitosamente', 1) :
      makeArrayToast('Hubo un error al crear el contador', 0);
  } catch (error) {
    return error.response?.data?.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}

/**
 * Actualiza un contador existente
 * @param {string} id - ID del contador (_id)
 * @param {Object} bookkeeperData - Datos del contador a actualizar
 * @returns {Promise<Array>} Respuesta con mensaje de éxito/error
 */
export async function updateBookkeeper(id, bookkeeperData) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/usuarios/bookkeepers/${encodeURIComponent(id)}`;

  console.log("Datos del contador a actualizar: ", bookkeeperData);

  try {
    const response = await axios.put(url, bookkeeperData);

    if (response.status >= 200 && response.status < 300) {
      console.log('Contador actualizado correctamente:', response.data);
      return makeArrayToast(response.data.message || 'Contador actualizado exitosamente', 1);
    } else {
      console.error('Error al actualizar el contador:', response.statusText);
      return makeArrayToast('Error al actualizar el contador', 0);
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Error desconocido, contacte con los devs";
    console.error('Error al realizar la solicitud PUT:', error.message);
    return makeArrayToast(errorMessage, 0);
  }
}

/**
 * Elimina un contador
 * @param {string} id - ID del contador a eliminar (_id)
 * @returns {Promise<Array>} Respuesta con mensaje de éxito/error
 */
export async function deleteBookkeeper(id) {
  const idEncoded = encodeURIComponent(id);
  const url = `${buildBaseUrl()}/usuarios/bookkeepers/${idEncoded}`;
  try {
    const response = await axios.delete(url);
    console.log("Response delete bookkeeper: ", response);
    return response.status === 200 ?
      makeArrayToast('Contador eliminado exitosamente.', 1) :
      makeArrayToast('Error al eliminar el contador', 0)
  } catch (error) {
    console.error(`Error al realizar la solicitud DELETE: ${error.message}`);
    return error.response?.data?.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}

// ===== Funciones API para Compras =====

/**
 * Busca compras con filtros avanzados
 * @param {Object} params - Parámetros de búsqueda
 * @returns {Promise<Object>} Lista de compras o conteo
 */
export async function getCompras({
  offset = 0,
  limit = 50,
  count = false,
  fecha_desde,
  fecha_hasta,
  fecha_dia,
  tipo_monto_mayor_que,
  tipo_monto_menor_que,
  tipo_monto_igual_que,
  uuid,
  nit_emisor,
  nombre_emisor,
  tipo_dte,
  anulado,
  order_by = 'desc',
  execute_pagination = true
} = {}) {
  const baseUrl = buildBaseUrl();
  const nit = getNit();

  // Construir query string
  const params = new URLSearchParams();
  params.append('nit', nit);
  params.append('offset', offset);
  params.append('limit', limit);

  if (count) params.append('count', 'TRUE');
  if (fecha_desde) params.append('fecha_desde', fecha_desde);
  if (fecha_hasta) params.append('fecha_hasta', fecha_hasta);
  if (fecha_dia) params.append('fecha_dia', fecha_dia);
  if (tipo_monto_mayor_que) params.append('tipo_monto_mayor_que', tipo_monto_mayor_que);
  if (tipo_monto_menor_que) params.append('tipo_monto_menor_que', tipo_monto_menor_que);
  if (tipo_monto_igual_que) params.append('tipo_monto_igual_que', tipo_monto_igual_que);
  if (uuid) params.append('uuid', uuid);
  if (nit_emisor) params.append('nit_emisor', nit_emisor);
  if (nombre_emisor) params.append('nombre_emisor', nombre_emisor);
  if (tipo_dte) {
    if (Array.isArray(tipo_dte)) {
      tipo_dte.forEach(t => params.append('tipo_dte', t));
    } else {
      params.append('tipo_dte', tipo_dte);
    }
  }
  if (anulado !== undefined) params.append('anulado', anulado);
  if (order_by) params.append('order_by', order_by);
  if (!execute_pagination) params.append('execute_pagination', 'FALSE');

  const url = `${baseUrl}/compras/busqueda?${params.toString()}`;

  try {
    const response = await axios.get(url);
    console.log('Compras obtenidas:', response);

    if (count) {
      return response.data.totalRegistros || 0;
    }

    return response.data || [];
  } catch (error) {
    console.error('Error al obtener las compras:', error);
    if (error.response?.status === 401) {
      return { error: 'No está autorizado para ver las compras de este NIT' };
    }
    return [];
  }
}

/**
 * Procesa un JSON de compra con IA
 * @param {string} nitEmisor - NIT del emisor del documento
 * @param {string} jsonBase64 - JSON del documento codificado en Base64
 * @returns {Promise<Object>} Resultado del procesamiento
 */
export async function processCompraWithAI(nitEmisor, jsonBase64) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/compras/ai/process/${nitEmisor}`;

  try {
    const response = await axios.post(url, { json: jsonBase64 });
    console.log('Compra procesada con IA:', response);
    return response.status === 201 ?
      { success: true, data: response.data.data, message: response.data.message } :
      { success: false, message: 'Error al procesar la compra' };
  } catch (error) {
    console.error('Error al procesar compra con IA:', error);
    const errorMessage = error.response?.data?.message || 'Error desconocido al procesar la compra';
    return { success: false, message: errorMessage };
  }
}

/**
 * Actualiza campos específicos de una compra
 * @param {string} uuid - UUID (codigoGeneracion) del documento
 * @param {Object} data - Campos a actualizar
 * @returns {Promise<Array>} Respuesta con mensaje de éxito/error
 */
export async function updateCompra(uuid, data) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/compras/${encodeURIComponent(uuid)}`;

  try {
    const response = await axios.patch(url, data);
    console.log('Compra actualizada:', response);

    if (response.status >= 200 && response.status < 300) {
      return makeArrayToast(response.data.message || 'Compra actualizada exitosamente', 1);
    } else {
      return makeArrayToast('Error al actualizar la compra', 0);
    }
  } catch (error) {
    console.error('Error al actualizar compra:', error);
    const errorMessage = error.response?.data?.message || 'Error desconocido al actualizar la compra';
    return makeArrayToast(errorMessage, 0);
  }
}

/**
 * Elimina una compra
 * @param {string} uuid - UUID (codigoGeneracion) del documento a eliminar
 * @returns {Promise<Array>} Respuesta con mensaje de éxito/error
 */
export async function deleteCompra(uuid) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/compras/${encodeURIComponent(uuid)}`;

  try {
    const response = await axios.delete(url);
    console.log('Compra eliminada:', response);
    return response.status === 200 ?
      makeArrayToast(response.data.message || 'Compra eliminada exitosamente', 1) :
      makeArrayToast('Error al eliminar la compra', 0);
  } catch (error) {
    console.error('Error al eliminar compra:', error);
    const errorMessage = error.response?.data?.message || 'Error desconocido al eliminar la compra';
    return makeArrayToast(errorMessage, 0);
  }
}

// ===== Funciones API para Buzones IMAP =====

/**
 * Obtiene la lista de buzones IMAP del usuario
 * @returns {Promise<Array>} Lista de buzones
 */
export async function getMailboxes() {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/mailboxes`;
  try {
    const response = await axios.get(url);
    console.log('Buzones obtenidos:', response);
    return response.data || [];
  } catch (error) {
    console.error('Error al obtener los buzones:', error);
    return [];
  }
}

/**
 * Obtiene un buzón por su ID
 * @param {string} id - ID del buzón
 * @returns {Promise<Object|null>} Buzón o null si no existe
 */
export async function getMailboxById(id) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/mailboxes/${encodeURIComponent(id)}`;
  try {
    const response = await axios.get(url);
    return response.data || null;
  } catch (error) {
    console.error('Error al obtener el buzón:', error);
    return null;
  }
}

/**
 * Crea un nuevo buzón IMAP
 * @param {Object} mailboxData - Datos del buzón
 * @returns {Promise<Object>} Respuesta con éxito/error
 */
export async function createMailbox(mailboxData) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/mailboxes`;
  try {
    const response = await axios.post(url, mailboxData);
    console.log('Buzón creado:', response);
    if (response.status === 201 || response.status === 200) {
      return {
        success: true,
        data: response.data,
        toast: makeArrayToast(response.data.message || 'Buzón creado exitosamente', 1)
      };
    }
    return {
      success: false,
      toast: makeArrayToast('Error al crear el buzón', 0)
    };
  } catch (error) {
    console.error('Error al crear buzón:', error);
    const errorMessage = error.response?.data?.message || 'Error desconocido al crear el buzón';
    return {
      success: false,
      toast: makeArrayToast(errorMessage, 0)
    };
  }
}

/**
 * Actualiza un buzón existente
 * @param {string} id - ID del buzón
 * @param {Object} mailboxData - Datos a actualizar
 * @returns {Promise<Object>} Respuesta con éxito/error
 */
export async function updateMailbox(id, mailboxData) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/mailboxes/${encodeURIComponent(id)}`;
  try {
    const response = await axios.put(url, mailboxData);
    console.log('Buzón actualizado:', response);
    if (response.status >= 200 && response.status < 300) {
      return {
        success: true,
        data: response.data,
        toast: makeArrayToast(response.data.message || 'Buzón actualizado exitosamente', 1)
      };
    }
    return {
      success: false,
      toast: makeArrayToast('Error al actualizar el buzón', 0)
    };
  } catch (error) {
    console.error('Error al actualizar buzón:', error);
    const errorMessage = error.response?.data?.message || 'Error desconocido al actualizar el buzón';
    return {
      success: false,
      toast: makeArrayToast(errorMessage, 0)
    };
  }
}

/**
 * Elimina un buzón
 * @param {string} id - ID del buzón a eliminar
 * @returns {Promise<Object>} Respuesta con éxito/error
 */
export async function deleteMailbox(id) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/mailboxes/${encodeURIComponent(id)}`;
  try {
    const response = await axios.delete(url);
    console.log('Buzón eliminado:', response);
    return response.status === 200 ?
      { success: true, toast: makeArrayToast(response.data.message || 'Buzón eliminado exitosamente', 1) } :
      { success: false, toast: makeArrayToast('Error al eliminar el buzón', 0) };
  } catch (error) {
    console.error('Error al eliminar buzón:', error);
    const errorMessage = error.response?.data?.message || 'Error desconocido al eliminar el buzón';
    return { success: false, toast: makeArrayToast(errorMessage, 0) };
  }
}

/**
 * Prueba la conexión de un buzón IMAP
 * @param {string} id - ID del buzón a probar
 * @returns {Promise<Object>} Resultado del test { success, message, error }
 */
export async function testMailboxConnection(id) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/mailboxes/${encodeURIComponent(id)}/test`;
  try {
    const response = await axios.post(url);
    console.log('Test de conexión:', response);
    return response.data;
  } catch (error) {
    console.error('Error al probar conexión:', error);
    return {
      success: false,
      error: error.response?.data?.error || 'Error al probar la conexión'
    };
  }
}

// ===== Funciones API para Importaciones IMAP =====

/**
 * Inicia una importación de emails desde los buzones IMAP
 * @param {Object} options - Opciones de importación
 * @param {string[]} options.mailboxIds - Array de IDs de buzones (opcional, si no se envía procesa todos)
 * @param {string} options.fromDate - Fecha inicio YYYY-MM-DD (opcional)
 * @param {string} options.toDate - Fecha fin YYYY-MM-DD (opcional)
 * @returns {Promise<Object>} { importId, status, message, mailboxes }
 */
export async function startImapImport(options = {}) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/imports/run`;
  try {
    const response = await axios.post(url, options);
    console.log('Importación iniciada:', response);
    return response.data;
  } catch (error) {
    console.error('Error al iniciar importación:', error);
    return {
      importId: null,
      status: 'error',
      message: error.response?.data?.message || 'Error al iniciar la importación'
    };
  }
}

/**
 * Obtiene el historial de importaciones
 * @param {number} skip - Registros a saltar (paginación)
 * @param {number} limit - Máximo de registros
 * @returns {Promise<Object>} { total, imports }
 */
export async function getImapImports(skip = 0, limit = 20) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/imports?skip=${skip}&limit=${limit}`;
  try {
    const response = await axios.get(url);
    console.log('Historial de importaciones:', response.data);
    // Normalizar respuesta: API devuelve { total, items }
    const data = response.data || { total: 0, items: [] };
    return {
      total: data.total || 0,
      imports: data.items || []
    };
  } catch (error) {
    console.error('Error al obtener historial:', error);
    return { total: 0, imports: [] };
  }
}

/**
 * Obtiene el detalle de una importación (para polling de progreso)
 * @param {string} importId - ID de la importación
 * @returns {Promise<Object>} Detalle completo de la importación
 */
export async function getImapImportDetail(importId) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/imports/${encodeURIComponent(importId)}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error al obtener detalle de importación:', error);
    return null;
  }
}

/**
 * Obtiene los documentos de una importación agrupados por NIT receptor
 * @param {string} importId - ID de la importación
 * @returns {Promise<Object>} { total, byReceptor }
 */
export async function getImapImportDocuments(importId) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/imports/${encodeURIComponent(importId)}/documents`;
  try {
    const response = await axios.get(url);
    return response.data || { total: 0, byReceptor: [] };
  } catch (error) {
    console.error('Error al obtener documentos:', error);
    return { total: 0, byReceptor: [] };
  }
}

/**
 * Obtiene los documentos con desglose por buzón
 * @param {string} importId - ID de la importación
 * @returns {Promise<Object>} { total, byReceptor } con info de mailbox
 */
export async function getImapImportDocumentsByMailbox(importId) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/imports/${encodeURIComponent(importId)}/documents/by-mailbox`;
  try {
    const response = await axios.get(url);
    return response.data || { total: 0, byReceptor: [] };
  } catch (error) {
    console.error('Error al obtener documentos por buzón:', error);
    return { total: 0, byReceptor: [] };
  }
}

// ===== Funciones API para Stage (Fase 4) =====

/**
 * Obtiene el resumen de documentos en stage agrupados por NIT
 * @returns {Promise<Object>} { total, totalSentOk, totalSentError, totalMontoStaged, byTipoDte, byNit }
 */
export async function getStageSummary() {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/stage/summary`;
  try {
    const response = await axios.get(url);
    console.log('Resumen de stage:', response.data);
    return response.data || { total: 0, byNit: [] };
  } catch (error) {
    console.error('Error al obtener resumen de stage:', error);
    return { total: 0, byNit: [] };
  }
}

/**
 * Obtiene lista paginada de documentos en stage
 * @param {Object} options - Opciones de filtrado
 * @param {string} options.nitReceptor - Filtrar por NIT receptor
 * @param {number} options.limit - Máximo de registros
 * @param {number} options.skip - Registros a saltar
 * @returns {Promise<Object>} { total, items }
 */
export async function getStageItems(options = {}) {
  const baseUrl = buildBaseUrl();
  const params = new URLSearchParams();
  if (options.nitReceptor) params.append('nitReceptor', options.nitReceptor);
  if (options.limit) params.append('limit', options.limit.toString());
  if (options.skip) params.append('skip', options.skip.toString());

  const url = `${baseUrl}/imap/stage/items?${params}`;
  try {
    const response = await axios.get(url);
    console.log('Items de stage:', response.data);
    return response.data || { total: 0, items: [] };
  } catch (error) {
    console.error('Error al obtener items de stage:', error);
    return { total: 0, items: [] };
  }
}

/**
 * Envía documentos del stage al API de compras
 * @param {Object} options - Opciones de envío
 * @param {boolean} options.sendAll - Enviar todos los documentos
 * @param {string[]} options.nitList - Solo enviar de estos NITs
 * @param {string[]} options.codigoGeneracionList - Solo enviar estos documentos
 * @returns {Promise<Object>} { total, sent, success, errors, skipped, details }
 */
export async function sendStageDocuments(options = {}) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/stage/send`;
  try {
    const response = await axios.post(url, options);
    console.log('Resultado de envío:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error al enviar documentos:', error);
    return {
      total: 0,
      sent: 0,
      success: 0,
      errors: 0,
      skipped: 0,
      details: [],
      error: error.response?.data?.message || 'Error al enviar documentos'
    };
  }
}

/**
 * Envía documentos de una importación específica al API de compras
 * @param {string} importId - ID de la importación
 * @param {Object} options - Opciones de envío (sendAll, nitList, codigoGeneracionList)
 * @returns {Promise<Object>} { total, sent, success, errors, skipped, details }
 */
export async function sendStageByImport(importId, options = {}) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/imap/stage/${encodeURIComponent(importId)}/send`;
  try {
    const response = await axios.post(url, options);
    console.log('Resultado de envío por importación:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error al enviar documentos de importación:', error);
    return {
      total: 0,
      sent: 0,
      success: 0,
      errors: 0,
      skipped: 0,
      details: [],
      error: error.response?.data?.message || 'Error al enviar documentos'
    };
  }
}
